// LLISTAT PROPIETATS ESTILS GRÀFICS
// font
// textAlign
// textBaseline
// fillStyle
// strokeStyle
// lineWidth
// lineJoin
// lineCap
// miterLimit
// globalAlpha
// globalCompositeOperation
// shadowColor
// shadowBlur
// shadowOffsetX
// shadowOffsetY

const styles = {
    textRight: {
        textAlign: 'right'
    },
    textLeft: {
        textAlign: 'left'
    },
    textCenter: {
        textAlign: 'center'
    },
    llegendaPetit: {
        font: '400 14px "Bw 3cat", Helvetica, Arial, sans-serif',
        textAlign: 'center',
        fillStyle: '#111617'
    },
    llegendaPetitBlanc: {
        font: '400 14px "Bw 3cat", Helvetica, Arial, sans-serif',
        textAlign: 'center',
        fillStyle: '#dce3e5'
    },
    llegendaPetitVPs: {
        font: '400 12px "Bw 3cat", Helvetica, Arial, sans-serif',
        textAlign: 'center',
        fillStyle: '#111617'
    },
    llegendaPetitBlancVPs: {
        font: '400 12px "Bw 3cat", Helvetica, Arial, sans-serif',
        textAlign: 'center',
        fillStyle: '#dce3e5'
    },
    llegendaGran: {
        font: '500 32px "Bw 3cat", Helvetica, Arial, sans-serif',
        textAlign: 'center',
        fillStyle: '#111617'
    },
    llegendaGranBlanc: {
        font: '500 32px "Bw 3cat", Helvetica, Arial, sans-serif',
        textAlign: 'center',
        fillStyle: '#dce3e5'
    },
    llegendaGranVPs: {
        font: '500 23px "Bw 3cat", Helvetica, Arial, sans-serif',
        textAlign: 'center',
        fillStyle: '#111617'
    },
    llegendaGranBlancVPs: {
        font: '500 23px "Bw 3cat", Helvetica, Arial, sans-serif',
        textAlign: 'center',
        fillStyle: '#dce3e5'
    },
    llegendaLight: {
        font: '400 12px "Bw 3cat", Helvetica, Arial, sans-serif',
        textAlign: 'center',
        fillStyle: '#455054'
    },
    llegendaLightBlanc: {
        font: '400 12px "Bw 3cat", Helvetica, Arial, sans-serif',
        textAlign: 'center',
        fillStyle: '#dce3e5'
    },
    llegendaLightVPs: {
        font: '400 10px "Bw 3cat", Helvetica, Arial, sans-serif',
        textAlign: 'center',
        fillStyle: '#455054'
    },
    llegendaLightBlancVPs: {
        font: '400 10px "Bw 3cat", Helvetica, Arial, sans-serif',
        textAlign: 'center',
        fillStyle: '#dce3e5'
    },
    marcaMajoriaAbsoluta: {
        strokeStyle: 'black',
        lineWidth: 1
    },
    marcaMajoriaAbsolutaBlanc: {
        strokeStyle: '#dce3e5',
        lineWidth: 1
    },
    lineLabel: {
        font: '10px "Bw 3cat", Helvetica, Arial, sans-serif',
        textAlign: 'left',
        textBaseline: 'middle'
    }
};

const setStyle = (ctx, styleName) => {
    const style = styles[styleName];

    if (!style) return;

    Object.entries(style).forEach(([key, value]) => {
        if (key in ctx) {
            ctx[key] = value;
        }
    });
};

const setDirectStyle = (styleName) => {
    const style = styles[styleName];
    return style || {};
};

export { setStyle, setDirectStyle };
